export default __webpack_public_path__ + "static/media/reversePokeball.a6af43ca.svg";